import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { DataService } from "./data.service";
import { ReferringPhysicianInstituteFilter } from "../model/referring-physician-institute-filter";
import { Observable } from "rxjs";
import { ReferringPhysicianInstituteEditInfo } from "../model/referring-physician/referring-physician-institute";

@Injectable({
  providedIn: "root",
})
export class ReferringPhysicianInstituteService {
  private readonly getReferringPhysicianInstituteFiltersEndPoint: string =
    "/referringPhysicianInstitute/getReferringPhysicianInstituteFilters/";
  private readonly rferringPhysicianInstituteUpdateEndPoint: string =
    "/referringPhysicianInstitute/referringPhysicianInstituteUpdate/";

  constructor(private http: HttpClient, private dataService: DataService) {}

  getReferringPhysicianInstituteFilters(
    filter: string
  ): Observable<ReferringPhysicianInstituteFilter[]> {
    if (!filter || filter === "") {
      return new Observable<ReferringPhysicianInstituteFilter[]>();
    }
    const params = { filter: filter };
    return this.dataService.get<ReferringPhysicianInstituteFilter[]>(
      this.getReferringPhysicianInstituteFiltersEndPoint,
      params
    );
  }

  update(info: ReferringPhysicianInstituteEditInfo): Promise<number> {
    return this.dataService
      .post<number>(this.rferringPhysicianInstituteUpdateEndPoint, info)
      .toPromise();
  }
}
